import { Link } from "react-router-dom";
import ProjectCard from "../projects/ProjectCard";
import projectsData from "../../../data/projectsData";

export default function RecentProjects() {
  const recent = projectsData.slice(0, 3);

  return (
    <div className="bg-white border border-gray-100 rounded-2xl p-6">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h2 className="font-bold text-gray-900">Recent Projects</h2>
          <p className="text-sm text-gray-500">Live tracking of your prototype builds</p>
        </div>
        <Link to="/app/projects" className="text-sm font-semibold text-indigo-600 hover:underline">
          View all →
        </Link>
      </div>

      <div className="space-y-5">
        {recent.map((p) => (
          <ProjectCard key={p.id} project={p} />
        ))}
      </div>
    </div>
  );
}